import * as Yup from 'yup'
import { v4 as uuidv4 } from 'uuid'

import { createDV360LineItemPayload, isAgeObjectContinuousRange } from '../../../lineItemHelpers'
import { createNameFromCustomAudiences } from '../../../../Multiplatform/LineItemForms/formatters'

import { LINE_ITEM } from '../../../../Multiplatform/UploadAdCreative/UploadAdCreativeLineItemForm/fields'
import {
  NAME,
  PIXELS
} from '../../../LineItemForms/LineItemDv360Create/LineItemDv360CreateForm/LineItemDV360CreateMainForm/fields'
import {
  END_DATE,
  endDateValidation,
  START_DATE,
  startDateValidation,
  startEndDateRangeInitialValues
} from '../../../../ReusableFormFields/StartEndDateRangeFields/fields'
import {
  dv360CustomAgeRangesInitialValues,
  FREQUENCY_IMPRESSIONS,
  FREQUENCY_OPTION,
  frequencyFields,
  PAUSED,
  STATUS
} from '../../../fields'
import { dv360AudiencesInitialValues } from '../../../LineItemForms/LineItemDv360Create/LineItemDv360CreateForm/LineItemDV360AudienceForm/fields'
import {
  AUDIENCES_OPTION,
  CUSTOM_AUDIENCES,
  CUSTOM_AUDIENCES_EXCLUSION
} from '../../../../ReusableFormFields/Audiences/AudiencesFields/fields'
import { OPTION_NO, OPTION_YES } from '../../../../../constants/forms'
import {
  initialGeolocationsValues,
  SHOW_OPTION,
  SHOW_OPTION_REGIONS,
  SHOW_REGIONS
} from '../../../../ReusableFormFields/GeolocationsFields/fields'
import { GENDER_OPTION } from '../../../../ReusableFormFields/GenderFields/fields'
import { LANGUAGES } from '../../../../ReusableFormFields/LanguagesFields/fields'
import { CUSTOM_AGE_RANGES } from '../../../../ReusableFormFields/AgeRangesFields/fields'
import {
  formattedContentInstreamPositionOptions,
  formattedContentOutstreamPositionOptions,
  formattedOnScreenPositionOptions
} from './Steps/PositionStep/fields'
import {
  LIST_ITEM_OPTION,
  OPTION_EXISTING_LIST_ITEM,
  OPTION_NEW_LIST_ITEM
} from '../../../../../hooks/formHooks/listItemFormHooks/fields'

export const TARGET_SPECIFIC_URLS_OR_APPS = 'target_specific_urls_or_apps'
export const YES_USING_PRE_SAVED_SITE_LISTS = 'yes_using_pre_saved_site_lists'
export const APPS = 'apps'
export const URLS = 'urls'
export const TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS = 'target_specific_categories_or_keywords'
export const YES_USING_PRE_SAVED_KEYWORD_EXCLUSION_LISTS = 'yes_using_pre_saved_keyword_exclusion_lists'
export const CHANNELS = 'channels'
export const CHANNELS_EXCLUDED = 'channels_excluded'

export const CATEGORIES = 'categories'
export const EXCLUDED_CATEGORIES = 'excluded_categories'
export const KEYWORDS_TABLE = 'keywords'
export const KEYWORD_EXCLUSION_LISTS = 'keyword_exclusion_listS'
export const EXCHANGE_OPTION = 'exchange_option'
export const ALL_EXCHANGES = 'all_exchanges'
export const CUSTOM_EXCHANGES = 'custom_exchanges'
export const VIEWABILITY = 'viewability'
export const VIEWABILITY_OPTION = 'viewability_option'

export const POSITION_OPTION = 'position_option'
export const SELECT_ALL_POSITIONS = 'select_all_positions'
export const CUSTOM_POSITIONS = 'custom_positions'
export const ON_SCREEN_POSITIONS = 'on_screen_positions'
export const CONTENT_INSTREAM_POSITIONS = 'content_instream_positions'
export const CONTENT_OUTSTREAM_POSITIONS = 'content_outstream_positions'

export const LINE_ITEM_TYPE = 'line_item_type'
export const DISPLAY_DEFAULT = 'display_default'
export const VIDEO_DEFAULT = 'video_default'

// safety
export const APPLY_THIRD_PARTY_VERIFIER = 'apply_third_party_verifier'
export const UNSPECIFIED = 'UNSPECIFIED'
export const EXCLUDE_HIGH_RISK = 'HR'
export const EXCLUDE_HIGH_MODERATE_RISK = 'HMR'
export const SAFETY_OPTIONS = 'safety_options'
export const CUSTOM_SEGMENT_IDS = 'custom_segment_ids'
export const EXCLUDE_UNRATEABLE = 'EXCLUDE_UNRATEABLE'
export const BLOCK_UNRATED_URLS = 'BLOCK_UNRATED_URLS'
export const ADULT = 'ADULT'
export const ALCOHOL = 'ALCOHOL'
export const ILLEGAL_DOWNLOADS = 'ILLEGAL_DOWNLOADS'
export const DRUGS = 'DRUGS'
export const HATE_SPEECH = 'HATE_SPEECH'
export const OFFENSIVE_LANGUAGE = 'OFFENSIVE_LANGUAGE'
export const VIOLENCE = 'VIOLENCE'
export const SUSPICIOUS_ACTIVITY = 'SUSPICIOUS_ACTIVITY'

export const UREATED_URLS_SEGMENT_ID = '1000001'

export const safetyOptions = [
  {
    value: ADULT,
    label: 'Adult',
    fieldName: 'excludedAdultRisk'
  },
  {
    value: ALCOHOL,
    label: 'Alcohol',
    fieldName: 'excludedAlcoholRisk'
  },
  {
    value: ILLEGAL_DOWNLOADS,
    label: 'Illegal Downloads',
    fieldName: 'excludedIllegalDownloadsRisk'
  },
  {
    value: DRUGS,
    label: 'Drugs',
    fieldName: 'excludedDrugsRisk'
  },
  {
    value: HATE_SPEECH,
    label: 'Hate Speech',
    fieldName: 'excludedHateSpeechRisk'
  },
  {
    value: OFFENSIVE_LANGUAGE,
    label: 'Offensive Language',
    fieldName: 'excludedOffensiveLanguageRisk'
  },
  {
    value: VIOLENCE,
    label: 'Violence',
    fieldName: 'excludedViolenceRisk'
  },
  {
    value: SUSPICIOUS_ACTIVITY,
    label: 'Ad Fraud Risk Filter',
    fieldName: 'excludedAdFraudRisk'
  }
]

export const safetyEnumsOptions = [
  {
    value: UNSPECIFIED,
    label: 'Allow All'
  },
  {
    value: EXCLUDE_HIGH_RISK,
    label: 'Exclude High Risk'
  },
  {
    value: EXCLUDE_HIGH_MODERATE_RISK,
    label: 'Exclude High and Moderate Risk'
  }
]

export const blockUnrateableOptions = [
  {
    value: OPTION_NO,
    label: 'No'
  },
  {
    value: OPTION_YES,
    label: 'Yes'
  }
]

export const getInitialValues = isLineItemsExist => {
  return {
    [LIST_ITEM_OPTION]: isLineItemsExist ? OPTION_EXISTING_LIST_ITEM : OPTION_NEW_LIST_ITEM,
    [LINE_ITEM_TYPE]: DISPLAY_DEFAULT,
    [LINE_ITEM]: '',

    // New LineItem initial values
    [NAME]: 'Broad targeting',
    // status
    [STATUS]: PAUSED,
    // pixels
    [PIXELS]: [],
    // dates
    ...startEndDateRangeInitialValues,
    // audiences
    ...dv360AudiencesInitialValues,
    [GENDER_OPTION]: '',
    [LANGUAGES]: [],
    [CUSTOM_AGE_RANGES]: dv360CustomAgeRangesInitialValues,
    ...initialGeolocationsValues,
    [TARGET_SPECIFIC_URLS_OR_APPS]: OPTION_NO,
    [APPS]: [
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined]
    ],
    [URLS]: [
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined]
    ],
    [CHANNELS]: [],
    [CHANNELS_EXCLUDED]: [],
    [TARGET_SPECIFIC_CATEGORIES_OR_KEYWORDS]: OPTION_NO,
    [CATEGORIES]: [],
    [EXCLUDED_CATEGORIES]: [],
    [KEYWORDS_TABLE]: [
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined],
      [undefined, undefined]
    ],
    [KEYWORD_EXCLUSION_LISTS]: [],
    [EXCHANGE_OPTION]: ALL_EXCHANGES,
    [CUSTOM_EXCHANGES]: [],
    [VIEWABILITY]: '',
    [VIEWABILITY_OPTION]: OPTION_NO,
    [POSITION_OPTION]: SELECT_ALL_POSITIONS,
    [CUSTOM_POSITIONS]: [],
    // preselect all positions
    [ON_SCREEN_POSITIONS]: [...formattedOnScreenPositionOptions],
    [CONTENT_INSTREAM_POSITIONS]: [...formattedContentInstreamPositionOptions],
    [CONTENT_OUTSTREAM_POSITIONS]: [...formattedContentOutstreamPositionOptions],

    [CUSTOM_EXCHANGES]: [],
    [APPLY_THIRD_PARTY_VERIFIER]: OPTION_NO,
    [SAFETY_OPTIONS]: safetyOptions.reduce((acc, safetyOption) => {
      acc[safetyOption.value] = UNSPECIFIED
      return acc
    }, {}),
    [CUSTOM_SEGMENT_IDS]: [{ text: '', id: uuidv4() }],
    [EXCLUDE_UNRATEABLE]: OPTION_NO,
    [BLOCK_UNRATED_URLS]: false,
    ...frequencyFields
  }
}

export const getValidationSchema = isPixelRequired => {
  return Yup.object({
    // line item
    [LINE_ITEM]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_EXISTING_LIST_ITEM,
      then: () => Yup.string().required('Please select line item')
    }),

    // pixels
    ...(isPixelRequired && {
      [PIXELS]: Yup.array().when(LIST_ITEM_OPTION, {
        is: OPTION_NEW_LIST_ITEM,
        then: () => Yup.array().min(1, 'Please select at least one pixel')
      })
    }),

    // dates
    [START_DATE]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () => startDateValidation
    }),
    [END_DATE]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () => endDateValidation
    }),

    // audiences
    [CUSTOM_AUDIENCES]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(AUDIENCES_OPTION, {
          is: OPTION_YES,
          then: () => Yup.array().min(1, 'Please select at least one option')
        })
    }),
    [CUSTOM_AUDIENCES_EXCLUSION]: Yup.array().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.array().when(CUSTOM_AUDIENCES_EXCLUSION, {
          is: true,
          then: () => Yup.array().min(1, 'Please select at least one option')
        })
    }),
    [SHOW_REGIONS]: Yup.array().when(SHOW_OPTION, {
      is: SHOW_OPTION_REGIONS,
      then: () => Yup.array().min(1, 'Please select at least one option')
    }),
    [CUSTOM_AGE_RANGES]: Yup.object().test({
      name: 'Custom age range validation',
      test: (ageObject, context) => {
        const selectedAgeRanges = Object.keys(ageObject).filter(ageItem => ageObject[ageItem])

        if (selectedAgeRanges.length > 0 && !isAgeObjectContinuousRange(ageObject)) {
          return context.createError({
            message: 'Please select continuous range of ages',
            path: CUSTOM_AGE_RANGES
          })
        }

        return true
      }
    }),
    [CUSTOM_EXCHANGES]: Yup.array().when(EXCHANGE_OPTION, {
      is: CUSTOM_EXCHANGES,
      then: () => Yup.array().min(1, 'Please select at least one exchange')
    }),
    [VIEWABILITY]: Yup.array().when(VIEWABILITY_OPTION, {
      is: OPTION_YES,
      then: () => Yup.string().required('Please select viewability')
    }),
    [CUSTOM_SEGMENT_IDS]: Yup.array().when(APPLY_THIRD_PARTY_VERIFIER, {
      is: OPTION_YES,
      then: () =>
        Yup.array().of(
          Yup.object().shape({
            text: Yup.string()
              // (each will be a 7 digit code starting with 1)
              .matches(/^[1]\d{6}$/, 'Please enter a valid segment ID')
              .required('Please enter a valid segment ID')
          })
        )
    }),
    [FREQUENCY_IMPRESSIONS]: Yup.string().when(LIST_ITEM_OPTION, {
      is: OPTION_NEW_LIST_ITEM,
      then: () =>
        Yup.string().when(FREQUENCY_OPTION, {
          is: OPTION_YES,
          then: () => Yup.string().required('This field is required')
        })
    })
  })
}

export const transformValuesToBE = (values, campaign) => {
  return createDV360LineItemPayload({
    name: `${createNameFromCustomAudiences(values[CUSTOM_AUDIENCES])} - ${uuidv4().slice(0, 7)}`,
    lineItemType: values[LINE_ITEM_TYPE],
    status: values[STATUS],
    startDate: values[START_DATE],
    endDate: values[END_DATE],
    pixels: values[PIXELS],
    campaign: campaign,
    values
  })
}
